import StepOne from "@/components/dashboard/receive/StepOne";

export default function ReceiveStepOne() {
  return <StepOne />;
}
